import { openBlock as c, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", { d: "M12.085 1.8A6.176 6.176 0 0 0 7.295.29c-2.75.31-5.01 2.53-5.36 5.28a6.16 6.16 0 0 0 2.63 5.87c.42.29.67.77.67 1.3V15c0 .41.34.75.75.75h4.03c.41 0 .75-.34.75-.75v-2.26c0-.52.27-1.02.71-1.33a6.109 6.109 0 0 0 2.64-5.04c0-1.74-.75-3.41-2.05-4.57h.02Zm-2.81 12.45h-2.53v-.87h2.53v.87Zm1.36-4.07c-.6.42-1.02 1.02-1.22 1.7h-.72V9.66l1.26-1.26c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.95.95-.94-.94a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.25 1.25v2.22h-.58a3.05 3.05 0 0 0-1.2-1.68 4.645 4.645 0 0 1-1.99-4.44c.26-2.07 1.96-3.75 4.04-3.98 1.33-.15 2.62.25 3.62 1.14a4.63 4.63 0 0 1 1.54 3.45c0 1.52-.75 2.94-2 3.8l.01.01Z" }, null, -1), n = [
  l
];
function h(a, r) {
  return c(), e("svg", o, [...n]);
}
const d = { render: h };
export {
  d as default,
  h as render
};
